import { render } from "./AposColorCheckerboard.vue?vue&type=template&id=215186e6"
import script from "./AposColorCheckerboard.vue?vue&type=script&lang=js"
export * from "./AposColorCheckerboard.vue?vue&type=script&lang=js"

import "./AposColorCheckerboard.vue?vue&type=style&index=0&id=215186e6&lang=css"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ui/ui/apos/components/AposColorCheckerboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "215186e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('215186e6', __exports__)) {
    api.reload('215186e6', __exports__)
  }
  
  module.hot.accept("./AposColorCheckerboard.vue?vue&type=template&id=215186e6", () => {
    api.rerender('215186e6', render)
  })

}


export default __exports__